import React from 'react';
import classNames from 'classnames';
import styles from './XComboBox.module.scss';
import { XControl } from '../../commons';
import { EPosition, ETheme } from '../../../types/enums';
import { IDropDownState } from './IDropDownState';
import { XComboBoxItem } from './XComboBoxItem';
import { IComboBoxItemProps } from './IComboBoxItemProps';
import { XDropDownSeeker } from './XDropDownSeeker';
import { IDropDownProps } from './IDropDownProps';

export class XDropDown extends XControl<HTMLDivElement, IDropDownProps, IDropDownState> {

    protected static defaultProps = {
        ...XControl.defaultProps,
        theme: ETheme.Blue,
        position: undefined
    }
    protected reference: React.RefObject<HTMLDivElement>;

    public constructor(props: IDropDownProps) {
        super(props);
        this.onMouseDownItem = this.onMouseDownItem.bind(this);
        this.onClickItem = this.onClickItem.bind(this);
        this.onSeekerText = this.onSeekerText.bind(this);
        this.reference = React.createRef<HTMLDivElement>();
    }

    private onMouseDownItem(event: React.MouseEvent<HTMLDivElement, MouseEvent>): void {
        event.preventDefault();
    }

    private onClickItem(item: XComboBoxItem): void {
        this.props.onClickItem?.(item);
    }

    private onSeekerText(value?: string | null) {
        this.props.onSeekerText?.(value);
    }

    public render(): React.ReactNode {
        return (
            <div ref={this.reference} className={styles.XDropDown} data-orientation={this.props.position} data-seeker={this.props.seeker}>
                {this.props.seeker
                    && <XDropDownSeeker
                        onText={this.onSeekerText}
                        show={this.props.position === EPosition.Bottom}
                    />
                }
                {this.props.children && <div className={styles.XDropDownItems}>
                    {React.Children.map(this.props.children, (i) => {
                        if(i == null)
                            return;
                        if(i.type !== XComboBoxItem)
                            return undefined;
                        const item = React.cloneElement(i as React.ReactElement<IComboBoxItemProps>, {
                            className: styles.XDropDownItem,
                            onClick: this.onClickItem,
                            onMouseDown: this.onMouseDownItem
                        });

                        return item;
                    })}
                </div>}
                {this.props.seeker
                    && <XDropDownSeeker
                        onText={this.onSeekerText}
                        show={this.props.position === EPosition.Top}
                    />
                }
            </div>
        );
    }

}
